import { apiRequest } from '@/domains/api';

/**
 * Who can edit the website — survey-api's `/api/v1/admin/website/editors` (its
 * `docs/superpowers/specs/2026-10-07-website-content-design.md` §5), and the sole reader of it.
 *
 * Every active account whose roles hold `content.author` or `content.publish`, publishers first.
 * `content.author` reads it, so a content editor sees who else works here without the roles or
 * accounts screens.
 */
export interface IContentEditor {
  accountId: string;
  email: string;
  /** Holds `content.author`: opens these screens and saves. */
  author: boolean;
  /** Holds `content.publish`: puts a record on the live site. */
  publish: boolean;
  /** The roles granting either permission, alphabetical. */
  roles: string[];
}

export const editorsApi = {
  list(signal?: AbortSignal): Promise<IContentEditor[]> {
    return apiRequest<IContentEditor[]>('/api/v1/admin/website/editors', { signal });
  }
};
